import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function markAlertsAsSeen(partNumbers, wishlistConfigs) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret } = wishlistConfigs;

    invariant(baseUrl, 'baseUrl is a required param of markAlertsAsSeen()');
    invariant(brandId, 'brandId is a required param of markAlertsAsSeen()');
    invariant(country, 'country is a required param of markAlertsAsSeen()');
    invariant(uberToken, 'uberToken is a required param of markAlertsAsSeen()');
    invariant(clientId, 'clientId is a required param of markAlertsAsSeen()');
    invariant(partNumbers, 'partNumbers is a required param of markAlertsAsSeen()');

    const headers = { 'Content-Type': 'application/json' };

    const fetchUrl = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/alerts/seen/wishlist/${partNumbers.join(',')}`;

    return labelRequest(
        authenticatedRequest(new Request(fetchUrl, { headers: new Headers(headers), method: 'PUT' }), uberToken, clientId, clientSecret),
        'markAlertsAsSeen',
    );
}
